import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { keyframes, css } from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { grid } from '@finect/tabular-utils/grid';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
var fade = keyframes(["0%{bottom:-90px;}100%{bottom:0;}"]);
export var Wrapper = styled.div.withConfig({
  displayName: "partials__Wrapper",
  componentId: "sc-o6xr2p-0"
})(["width:100%;", " ", " border:1px solid ", ";background-color:", ";", ""], function (_ref) {
  var position = _ref.position;
  return position === 'fixed' && css(["position:fixed;z-index:220;bottom:0;left:0;box-shadow:0 0 8px 0 rgb(46 46 51 / 0.08);animation:", " 0.5s ease-in;"], fade);
}, function (_ref2) {
  var position = _ref2.position;
  return position === 'initial' && css(["position:initial;margin-top:12px;"]);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.terciaryL;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.terciaryLL;
}, function (_ref5) {
  var marginBottom = _ref5.marginBottom;
  return marginBottom ? 'margin-bottom: 72px' : '';
});
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-o6xr2p-1"
})(["display:grid;grid-template-columns:1fr 1fr 1fr;align-items:center;max-width:", "px;padding:24px 30px;margin:0 auto;", ";", ";"], grid(10) + 60, getFont(0), maxMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    justify-items: center;\n    grid-template: 2fr  / 1fr 1fr;\n    grid-template-areas: 'info info' 'action reset';\n\n    div, span {\n      margin: 8px 0;\n    }\n    padding: 4px;\n  "]))));
export var WrapperActionButton = styled.div.withConfig({
  displayName: "partials__WrapperActionButton",
  componentId: "sc-o6xr2p-2"
})(["", ";"], maxMediaQueries.phablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    grid-area: action;\n  "]))));
export var Info = styled.span.withConfig({
  displayName: "partials__Info",
  componentId: "sc-o6xr2p-3"
})(["display:flex;justify-content:center;font-weight:600;color:", ";", ";> svg{color:", ";}> span{margin-left:6px;}", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.terciaryDD;
}, getFont(0), function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.primary;
}, maxMediaQueries.phablet(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    grid-area: info;\n    align-items: center;\n  "]))));
export var ResetButton = styled.span.withConfig({
  displayName: "partials__ResetButton",
  componentId: "sc-o6xr2p-4"
})(["cursor:pointer;font-weight:600;color:", ";text-align:right;", ";", " ", ";"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.primary;
}, getFont(0), function (_ref9) {
  var disabled = _ref9.disabled;
  return disabled && css(["cursor:not-allowed;color:", ";"], function (_ref10) {
    var theme = _ref10.theme;
    return theme.colors.fontLL;
  });
}, maxMediaQueries.phablet(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    grid-area: reset;\n  "]))));